var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"daily"},[_c('div',{staticClass:"bg"}),_c('video',{ref:"bg",staticClass:"bg-image",attrs:{"autoplay":"","muted":""},domProps:{"muted":true}}),_c('video',{ref:"vid",staticClass:"video",attrs:{"autoplay":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }